(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-header]');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (header && toggle) {
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hx-dock"] && !Shopify.designMode) return;
  try {
    
  function initHxDock() {
    const bar = document.querySelector('[data-hx-dock]');
    if (!bar) return;

    const anchor =
      document.querySelector('[data-hx-atc-anchor]') ||
      document.querySelector('[data-add-to-cart]');
    const stickyBtn = bar.querySelector('[data-hx-dock-atc]');
    const form = document.querySelector('[data-product-section] form');
    const livePrice = document.querySelector('[data-price]');
    const dockPrice = bar.querySelector('[data-hx-dock-price]');

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if (anchor) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            setVisible(!entry.isIntersecting);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -8% 0px' }
      );
      observer.observe(anchor);
    }

    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }

    if (livePrice && dockPrice) {
      const syncPrice = function () {
        dockPrice.textContent = livePrice.textContent;
      };
      syncPrice();
      const priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(livePrice, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHxDock);
  } else {
    initHxDock();
  }

  document.addEventListener('shopify:section:load', initHxDock);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hx-quotes"] && !Shopify.designMode) return;
  try {
    
  (function initHxQuotes() {
    if (window.__hxQuotesReady) return;
    window.__hxQuotesReady = true;

    function setup(root) {
      if (!root || root.dataset.hxQuotesBound === 'true') return;
      root.dataset.hxQuotesBound = 'true';

      var track = root.querySelector('[data-hx-quotes-track]');
      var group = root.querySelector('[data-hx-quotes-group]');
      if (!track || !group) return;

      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var pauseHover = root.getAttribute('data-pause-hover') !== 'false';

      if (autoplay && group.children.length) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(function (el) {
          el.removeAttribute('id');
        });
        track.appendChild(clone);
      }

      if (pauseHover && autoplay) {
        root.addEventListener('mouseenter', function () {
          root.classList.add('is-paused');
        });
        root.addEventListener('mouseleave', function () {
          root.classList.remove('is-paused');
        });
        root.addEventListener('focusin', function () {
          root.classList.add('is-paused');
        });
        root.addEventListener('focusout', function () {
          root.classList.remove('is-paused');
        });
      }
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-hx-quotes]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan(document);
      });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  function initHxProduct(root) {
    if (!root || root.dataset.hxProductReady === 'true') return;
    root.dataset.hxProductReady = 'true';

    const variantsEl = root.querySelector('[data-variants-json]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const variantInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const atcBtn = root.querySelector('[data-add-to-cart]');
    const atcText = root.querySelector('[data-atc-text]');
    const stage = root.querySelector('[data-media-stage]');
    const stageWrap = root.querySelector('.hx-pdp__stage-wrap');
    const modelToggle = root.querySelector('[data-model-toggle]');
    const modelBanner = root.querySelector('[data-model-banner]');
    const modelText = root.querySelector('[data-model-text]');
    const skuWrap = root.querySelector('[data-sku]');
    const skuValue = root.querySelector('[data-sku-value]');
    const inventoryEl = root.querySelector('[data-inventory]');
    const thumbs = root.querySelectorAll('[data-variant-thumbs] [data-thumb-src]');
    const colorOptionIndex = Number(root.getAttribute('data-color-option-index') || 0);
    const defaultAtc = atcText ? atcText.textContent.trim() : 'Add to cart';
    const inventoryThreshold = Number(root.getAttribute('data-inventory-threshold') || 8);
    const inventoryLow = root.getAttribute('data-inventory-low') || 'Only [count] left';
    const inventoryIn = root.getAttribute('data-inventory-in') || 'In stock';
    const inventoryOut = root.getAttribute('data-inventory-out') || 'Sold out';
    let modelOpen = false;
    let lastColorValue = '';
    let skipGalleryScrollOnce = true;

    function scrollGalleryIntoViewOnMobile() {
      if (window.matchMedia('(min-width: 960px)').matches) return;
      var gallery = root.querySelector('.hx-pdp__gallery');
      if (!gallery) return;
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function setModelSizing(text) {
      if (!modelToggle || !modelBanner || !modelText) return;
      const value = (text || '').trim();
      if (!value) {
        modelToggle.hidden = true;
        modelBanner.hidden = true;
        modelOpen = false;
        modelToggle.setAttribute('aria-expanded', 'false');
        if (stageWrap) stageWrap.classList.remove('is-model-open');
        if (stage) stage.classList.remove('is-model-open');
        modelText.textContent = '';
        return;
      }
      modelText.textContent = value;
      modelToggle.hidden = false;
      if (!modelOpen) {
        modelBanner.hidden = true;
        modelToggle.setAttribute('aria-expanded', 'false');
        if (stageWrap) stageWrap.classList.remove('is-model-open');
        if (stage) stage.classList.remove('is-model-open');
      }
    }

    function toggleModelSizing() {
      if (!modelToggle || !modelBanner || modelToggle.hidden) return;
      modelOpen = !modelOpen;
      modelBanner.hidden = !modelOpen;
      modelToggle.setAttribute('aria-expanded', modelOpen ? 'true' : 'false');
      if (stageWrap) stageWrap.classList.toggle('is-model-open', modelOpen);
      if (stage) stage.classList.toggle('is-model-open', modelOpen);
    }

    function selectedOptions() {
      const selected = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        const index = Number(fieldset.getAttribute('data-option-index'));
        const input = fieldset.querySelector('[data-option-input]:checked');
        if (input) selected[index] = input.value;
      });
      return selected;
    }

    function updateOptionLabels() {
      root.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        const input = fieldset.querySelector('[data-option-input]:checked');
        const label = fieldset.querySelector('[data-option-label]');
        if (label && input) {
          label.textContent = input.value;
        }
      });
    }

    function findVariant() {
      const selected = selectedOptions();
      if (!selected.length) return variants[0];
      return variants.find(function (variant) {
        return selected.every(function (value, index) {
          return !value || variant.options[index] === value;
        });
      });
    }

    function setStageImage(src, alt, modelSizing) {
      if (!stage || !src) return;

      var mediaEl = stage.querySelector('img.hx-pdp__stage-img, img.hx-pdp__stage-media, video.hx-pdp__stage-media, .hx-pdp__stage-ph');

      if (mediaEl && mediaEl.tagName === 'IMG') {
        mediaEl.removeAttribute('srcset');
        mediaEl.removeAttribute('sizes');
        mediaEl.src = src;
        mediaEl.setAttribute('src', src);
        if (alt) mediaEl.alt = alt;
      } else if (mediaEl && mediaEl.tagName === 'VIDEO') {
        mediaEl.remove();
        mediaEl = null;
      }

      if (!mediaEl || mediaEl.tagName !== 'IMG') {
        if (mediaEl) mediaEl.remove();
        var img = document.createElement('img');
        img.className = 'hx-pdp__stage-img hx-pdp__stage-media';
        img.src = src;
        img.alt = alt || '';
        stage.insertBefore(img, stage.firstChild);
      }

      if (typeof modelSizing !== 'undefined') {
        setModelSizing(modelSizing);
      }
    }

    function filterGallery(colorValue, preferredSrc) {
      if (!thumbs.length) return;
      const color = (colorValue || '').toLowerCase();
      let firstVisible = null;
      let preferredThumb = null;

      thumbs.forEach(function (thumb) {
        const colors = (thumb.getAttribute('data-media-colors') || '__all__').toLowerCase();
        const show =
          colors === '__all__' ||
          !color ||
          colors.split('|').indexOf(color) !== -1;
        thumb.classList.toggle('is-hidden', !show);
        thumb.classList.remove('is-active');
        if (show) {
          if (!firstVisible) firstVisible = thumb;
          if (preferredSrc && thumb.getAttribute('data-thumb-src') === preferredSrc) {
            preferredThumb = thumb;
          }
        }
      });

      const active = preferredThumb || firstVisible;
      if (active) {
        active.classList.add('is-active');
        setStageImage(
          active.getAttribute('data-thumb-src'),
          '',
          active.getAttribute('data-model-sizing') || ''
        );
      }
    }

    function updateVariant() {
      updateOptionLabels();

      const variant = findVariant();
      if (!variant || !variantInput) {
        if (atcBtn && atcText && !variant) {
          atcBtn.disabled = true;
          atcText.textContent = 'Unavailable';
        }
        return;
      }

      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) {
        if (variant.compare) {
          compareEl.hidden = false;
          compareEl.textContent = variant.compare;
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }
      if (atcBtn && atcText) {
        atcBtn.disabled = !variant.available;
        atcText.textContent = variant.available ? defaultAtc : 'Sold out';
      }
      if (skuWrap && skuValue) {
        if (variant.sku) {
          skuWrap.hidden = false;
          skuValue.textContent = variant.sku;
        } else {
          skuWrap.hidden = true;
        }
      }
      if (inventoryEl) {
        if (!variant.inventory_management) {
          inventoryEl.hidden = true;
        } else {
          inventoryEl.hidden = false;
          if (!variant.available) {
            inventoryEl.textContent = inventoryOut;
          } else if (variant.inventory > 0 && variant.inventory <= inventoryThreshold) {
            inventoryEl.textContent = inventoryLow.replace('[count]', String(variant.inventory));
          } else {
            inventoryEl.textContent = inventoryIn;
          }
        }
      }

      const colorValue =
        colorOptionIndex >= 0 && variant.options[colorOptionIndex]
          ? variant.options[colorOptionIndex]
          : '';
      if (colorOptionIndex >= 0 && colorValue) {
        filterGallery(colorValue, variant.image);
        if (colorValue !== lastColorValue) {
          lastColorValue = colorValue;
          if (!skipGalleryScrollOnce) {
            scrollGalleryIntoViewOnMobile();
          }
        }
      } else if (variant.image) {
        const matchThumb = Array.prototype.find.call(thumbs, function (thumb) {
          return thumb.getAttribute('data-thumb-src') === variant.image;
        });
        setStageImage(
          variant.image,
          '',
          matchThumb ? matchThumb.getAttribute('data-model-sizing') || '' : ''
        );
      }
      skipGalleryScrollOnce = false;
    }

    if (modelToggle) {
      modelToggle.addEventListener('click', function (event) {
        event.preventDefault();
        toggleModelSizing();
      });
    }

    root.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-option-input]')) {
        updateVariant();
      }
    });

    root.addEventListener('click', function (event) {
      const label = event.target.closest('.hx-pdp__swatch, .hx-pdp__pill');
      if (!label) return;
      const input = label.querySelector('[data-option-input]');
      if (!input) return;
      window.setTimeout(updateVariant, 0);
    });

    const qtyInput = root.querySelector('[data-qty-input]');
    const minus = root.querySelector('[data-qty-minus]');
    const plus = root.querySelector('[data-qty-plus]');
    if (minus && qtyInput) {
      minus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
      });
    }
    if (plus && qtyInput) {
      plus.addEventListener('click', function () {
        qtyInput.value = Number(qtyInput.value || 1) + 1;
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (thumb.classList.contains('is-hidden')) return;
        thumbs.forEach(function (el) {
          el.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        setStageImage(
          thumb.getAttribute('data-thumb-src'),
          '',
          thumb.getAttribute('data-model-sizing') || ''
        );
      });
    });

    const dialog = root.querySelector('[data-size-guide]');
    const openBtn = root.querySelector('[data-open-size-guide]');
    const closeBtn = root.querySelector('[data-close-size-guide]');
    if (dialog && openBtn) {
      openBtn.addEventListener('click', function () {
        dialog.showModal();
      });
    }
    if (dialog && closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }
    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    updateVariant();
  }

  function bootHxProduct() {
    document.querySelectorAll('[data-product-section]').forEach(initHxProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootHxProduct);
  } else {
    bootHxProduct();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const sectionRoot = event.target.querySelector
      ? event.target.querySelector('[data-product-section]')
      : null;
    if (sectionRoot) initHxProduct(sectionRoot);
    else if (event.target.matches && event.target.matches('[data-product-section]')) {
      initHxProduct(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function initHxReviews() {
    if (window.__hxReviewsReady) return;
    window.__hxReviewsReady = true;

    function setup(root) {
      if (!root || root.dataset.hxReviewsBound === 'true') return;
      root.dataset.hxReviewsBound = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-hx-review-item]'));
      var btn = root.querySelector('[data-hx-reviews-more]');
      if (!items.length || !btn) return;

      var initial = Number(root.getAttribute('data-initial') || 6);
      var step = Number(root.getAttribute('data-load-more') || 6);
      var shown = initial;

      function reveal() {
        var next = shown + step;
        items.forEach(function (item, index) {
          if (index < next) item.hidden = false;
        });
        shown = Math.min(next, items.length);
        if (shown >= items.length) btn.hidden = true;
      }

      btn.addEventListener('click', reveal);
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-hx-reviews]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan(document);
      });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  const bar = document.querySelector('[data-sticky-bar]');
  const buyBox = document.querySelector('[data-add-to-cart]');
  const stickyBtn = document.querySelector('[data-sticky-atc]');
  const form = document.querySelector('[data-product-section] form');

  if (bar && buyBox) {
    bar.hidden = false;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(buyBox);
  }

  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', () => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
